import { render, staticRenderFns } from "./cavu-button.vue?vue&type=template&id=b1e95172&scoped=true"
import script from "./cavu-button.vue?vue&type=script&lang=ts"
export * from "./cavu-button.vue?vue&type=script&lang=ts"
import style0 from "./cavu-button.vue?vue&type=style&index=0&id=b1e95172&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e95172",
  null
  
)

export default component.exports